import member1 from "../assets/mepic.jpg";
import member2 from "../assets/pards.jpg";
import member3 from "../assets/aron.png";
import member4 from "../assets/alde.png";
import member5 from "../assets/boneo.jpg";

export const projectsDummyData = [
  {
    id: 1,
    projectname: "E-Commerce Platform",
    status: "Completed",
    teams: [member1, member2, member3],
    completionrate: "100",
    startdate: "2024-01-02"
  },
  {
    id: 2,
    projectname: "Mobile Banking App",
    status: "In Progress",
    teams: [member2, member4, member5],
    completionrate: "60",
    startdate: "2024-04-20"
  },
  {
    id: 3,
    projectname: "Healthcare Management System",
    status: "Not Started",
    teams: [member3, member1, member5],
    completionrate: "0",
    startdate: ""
  },
  {
    id: 4,
    projectname: "CRM Software",
    status: "Completed",
    teams: [member4, member2, member3, member1],
    completionrate: "100",
    startdate: "2024-02-14"
  },
  {
    id: 5,
    projectname: "Educational Platform",
    status: "In Progress",
    teams: [member1, member5, member2],
    completionrate: "50",
    startdate: "2024-03-02"
  },
  {
    id: 6,
    projectname: "Inventory Management System",
    status: "In Progress",
    teams: [member3, member4, member1],
    completionrate: "80",
    startdate: "2024-04-10"
  },
  {
    id: 7,
    projectname: "Project Management Tool",
    status: "Completed",
    teams: [member2, member5, member3],
    completionrate: "100",
    startdate: "2024-02-20"
  },
  {
    id: 8,
    projectname: "Social Media App",
    status: "Not Started",
    teams: [member4, member1, member5],
    completionrate: "0",
    startdate: ""
  },
  {
    id: 9,
    projectname: "Online Learning System",
    status: "Completed",
    teams: [member1, member3, member5, member2],
    completionrate: "100",
    startdate: "2024-01-14"
  },
  {
    id: 10,
    projectname: "ERP Solution",
    status: "In Progress",
    teams: [member3, member4, member5],
    completionrate: "30",
    startdate: "2024-05-01"
  },
  {
    id: 11,
    projectname: "HR Management System",
    status: "Not Started",
    teams: [member1, member2],
    completionrate: "0",
    startdate: ""
  },
  {
    id: 12,
    projectname: "Customer Support System",
    status: "In Progress",
    teams: [member2, member3, member4],
    completionrate: "45",
    startdate: "2024-01-10"
  },
  {
    id: 13,
    projectname: "AI Chatbot",
    status: "Completed",
    teams: [member5, member1, member4],
    completionrate: "100",
    startdate: "2024-02-25"
  },
  {
    id: 14,
    projectname: "Data Analytics Platform",
    status: "In Progress",
    teams: [member1, member3, member5],
    completionrate: "70",
    startdate: "2024-03-14"
  },
  {
    id: 15,
    projectname: "Cloud Storage Solution",
    status: "Not Started",
    teams: [member2, member4, member3],
    completionrate: "0",
    startdate: ""
  },
  {
    id: 16,
    projectname: "Marketing Automation Tool",
    status: "Completed",
    teams: [member1, member2, member4],
    completionrate: "100",
    startdate: "2024-05-16"
  },
  {
    id: 17,
    projectname: "Fleet Management System",
    status: "In Progress",
    teams: [member3, member5, member1],
    completionrate: "40",
    startdate: "2024-05-01"
  },
  {
    id: 18,
    projectname: "Video Conferencing App",
    status: "Not Started",
    teams: [member4, member2, member5],
    completionrate: "0",
    startdate: ""
  },
  {
    id: 19,
    projectname: "IoT Dashboard",
    status: "Completed",
    teams: [member1, member3, member4],
    completionrate: "100",
    startdate: "2024-02-28"
  },
  {
    id: 20,
    projectname: "Travel Booking System",
    status: "In Progress",
    teams: [member2, member5, member1],
    completionrate: "55",
    startdate: "2024-02-01"
  }
];
